import { STATS } from "@/lib/constants";
import type { GbTier } from "@/lib/pricing-utils";

// Fallback used when the live products API is unavailable — mirrors the
// per-GB card so both pricing approaches stay in sync.
export const FALLBACK_RES_TIERS: GbTier[] = [
  { gb: 25, monthlyPPG: 1, totalPrice: 25 },
  { gb: 50, monthlyPPG: 1, totalPrice: 50 },
  { gb: 100, monthlyPPG: 1, totalPrice: 100 },
  { gb: 200, monthlyPPG: 1, totalPrice: 200 },
  { gb: 500, monthlyPPG: 1, totalPrice: 500 },
  { gb: 1000, monthlyPPG: 1, totalPrice: 1000 },
  { gb: 2000, monthlyPPG: 0.95, totalPrice: 1900 },
  { gb: 5000, monthlyPPG: 0.95, totalPrice: 4750 },
  { gb: 10000, monthlyPPG: 0.9, totalPrice: 9000 },
];

// Plan names for the first four tiers, by position.
export const CARD_PLAN_NAMES = ["Lite", "Standard", "Plus", "Scale"];

// Top highlights — the same set is shown on every card.
export const CARD_HIGHLIGHTS = [
  "Unused data rolls over",
  "City & ISP targeting",
  "HTTP, HTTPS & SOCKS5",
  "Real-time dashboard & API",
];

// Shared across every tier — shown once below the cards, not repeated per card.
export const PLAN_FEATURES = [
  "Unused bandwidth rolls over",
  `${STATS.ips} real residential IPs worldwide`,
  `${STATS.countries} countries, city-level & ISP targeting`,
  "HTTP, HTTPS & SOCKS5 support",
  "99.9% platform uptime",
  "Real-time dashboard & API access",
  "24/7 premium support",
];
